import {
  Button,
  Col,
  Input,
  Modal,
  QRCode,
  Row,
  Select,
  Switch,
  Typography,
} from "antd";
import "./addAlertReceiverModal.scss";
import React, { useEffect, useState } from "react";
import { HandleErrors } from "../../utils/handleErrors";
import { toast } from "react-toastify";
import { GetReportFilterReq } from "../../interfaces/event.interface";
import { newReportService } from "../../services/report.service";
import { AdminCreateUserReq } from "../../interfaces/user.interface";
import { GetRoleRes } from "../../interfaces/role.interface";
import { getRolesService } from "../../services/role.service";
import { adminCreateUserService } from "../../services/user.service";
import { NewAlertReceiverReq } from "../../interfaces/alert.interface";
import { newAlertReceiverService } from "../../services/alert.service";

interface Props {
  show: boolean;
  onClose: () => void;
}

export const AddAlertReceiverModal: React.FC<Props> = (props) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState<NewAlertReceiverReq>({
    name: "",
    active: true,
    email_address: "",
    type: "",
    webhook_uri: "",
  });

  const [roles, setRoles] = useState<GetRoleRes[]>([]);

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    try {
      const res = await getRolesService({});
      setRoles(res.list);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const submit = async () => {
    try {
      if (!data.name || !data.type) {
        toast.error("مقدار اجباری را وارد کنید");
        return;
      }

      if (data.type === "email" && !data.email_address) {
        toast.error("مقدار اجباری را وارد کنید");
        return;
      }

      if (data.type === "webhook" && !data.webhook_uri) {
        toast.error("مقدار اجباری را وارد کنید");
        return;
      }
      setLoading(true);

      const res = await newAlertReceiverService(data);

      setData({
        name: "",
        active: true,
        email_address: "",
        type: "",
        webhook_uri: "",
      });
      props.onClose();
      setShow(false);
      toast.success("اطلاعات با موفقیت ثبت شد.");
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="AddAlertReceiverModal">
      <Modal
        destroyOnClose={true}
        title={"افزودن گیرنده جدید"}
        onCancel={() => {
          setShow(false);
          props.onClose();
          setData({
            name: "",
            active: true,
            email_address: "",
            type: "",
            webhook_uri: "",
          });
        }}
        open={show}
        footer={null}
        width={500}
      >
        <div className="AddAlertReceiverModalContent">
          <Row justify={"space-between"}>
            <Col xs={24} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>نام:{" "}
              </Typography.Text>
              <Input
                className="input"
                value={data.name}
                onChange={(e) => {
                  setData({
                    ...data,
                    name: e.target.value,
                  });
                }}
              />
            </Col>
            <Col xs={24} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>نوع:
              </Typography.Text>
              <Select
                className="input"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  ((option?.label as string) ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                value={data.type}
                onSelect={(e) => {
                  setData({
                    ...data,
                    type: e,
                  });
                }}
              >
                <Select.Option label={`ایمیل`} value={"email"}>
                  ایمیل
                </Select.Option>
                <Select.Option label={`وب هوک`} value={"webhook"}>
                  وب هوک
                </Select.Option>
              </Select>
            </Col>
            {data.type === "email" && (
              <Col xs={24} className="input-box">
                <Typography.Text className="title">
                  <span style={{ color: "red" }}>*</span>
                  آدرس ایمیل:{" "}
                </Typography.Text>
                <Input
                  className="input"
                  value={data.email_address}
                  onChange={(e) => {
                    setData({
                      ...data,
                      email_address: e.target.value,
                    });
                  }}
                />
              </Col>
            )}
            {data.type === "webhook" && (
              <Col xs={24} className="input-box">
                <Typography.Text className="title">
                  <span style={{ color: "red" }}>*</span>
                  آدرس وب هوک:{" "}
                </Typography.Text>
                <Input
                  className="input"
                  value={data.webhook_uri}
                  onChange={(e) => {
                    setData({
                      ...data,
                      webhook_uri: e.target.value,
                    });
                  }}
                />
              </Col>
            )}
          </Row>
          <Row justify={"space-between"} align={"middle"} className="input-box">
            <Col>
              <Typography.Text className="title">وضعیت</Typography.Text>
            </Col>
            <Col>
              <Switch
                checked={data.active}
                onChange={(e) => {
                  setData({
                    ...data,
                    active: e,
                  });
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={24} className="btn-box">
              <Button
                loading={loading}
                onClick={submit}
                block
                type="primary"
                className="btn"
              >
                ثبت
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
